// Pure helpers of the Settings tab's Topology and Firewall sections (feature spec 17, phase 2; spec 11 6.15.12).
import type { NetworkKinds, ProviderNetworkSettings } from '../../api/types';

export type FirewallForm = NonNullable<ProviderNetworkSettings['firewall']>;

/** The cheapest sensible firewall price per region of the network's providers ("From about USD 912/month"). */
export function firewallFromCost(
  firewalls: NetworkKinds['firewalls'],
  providers: readonly string[],
): string | null {
  for (const provider of providers) {
    const costs = firewalls.find((f) => f.provider === provider && f.status === 'available')?.tierCosts;
    const cost = costs?.standard ?? Object.values(costs ?? {})[0];
    if (cost) return `${cost.currency} ${cost.monthly.toLocaleString('en-US')}`;
  }
  return null;
}

/** The firewall entries the Settings tab offers: available ones of the network's providers, and configured ones. */
export function offeredFirewalls(
  firewalls: NetworkKinds['firewalls'],
  providers: readonly string[],
  configured: readonly string[],
): NetworkKinds['firewalls'] {
  return firewalls.filter(
    (f) => providers.includes(f.provider) && (f.status === 'available' || configured.includes(f.provider)),
  );
}
